const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),
	$domTestimonialsSlider: $('.js-testimonials-slider'),

	/** @description Initialize. */
	init: function() {
		this.initGallerySlider();
		this.initTestimonialsSlider();
	},

	/** @description Set and run gallery slider. */
	initGallerySlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			mobileBreakpoint: 767,
			prevArrow: $('.js-slick-arrow-prev'),
			nextArrow: $('.js-slick-arrow-next'),
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}
			]
		};

		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSlider, config);
	},

	/** @description Set and run gallery slider. */
	initTestimonialsSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options
		const extraConfig = {
			slidesToShow: 1,
			infinite: true,
			prevArrow: $('.js-testimonials-arrow-prev'),
			nextArrow: $('.js-testimonials-arrow-next'),
		};

		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domTestimonialsSlider, config);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		const {mobileBreakpoint, ...slickConfig} = config;

		$slider.each((i, el) => {
			const $currentSlider = $(el); // Trenutni slider
			const $wrapper = $currentSlider.closest('.js-slider-wrapper'); // Pronađi wrapper slidera
			const $progressBar = $wrapper.find('.js-slider-progress-bar'); // Pronađi povezani progress bar
			const totalSlides = $currentSlider.children().length; // Broj slidova

			if (totalSlides <= slickConfig.slidesToShow && mobileBreakpoint) {
				const mq = window.matchMedia(`(max-width: ${mobileBreakpoint}px)`);

				const initAsSlider = () => {
					$wrapper.removeClass('no-slide');
					$currentSlider.removeClass('is-grid');
					if (!$currentSlider.hasClass('slick-initialized')) {
						$currentSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
							if ($progressBar.length) {
								const calc = (nextSlide / (slick.slideCount - 1)) * 100;
								$progressBar.css('background-size', calc + '% 100%');
							}
						});
						$currentSlider.slick(slickConfig);
					}
				};

				const initAsGrid = () => {
					if ($currentSlider.hasClass('slick-initialized')) {
						$currentSlider.off('beforeChange');
						$currentSlider.slick('unslick');
					}
					$wrapper.addClass('no-slide');
					$currentSlider.addClass('is-grid');
				};

				mq.addEventListener('change', (e) => e.matches ? initAsSlider() : initAsGrid());
				mq.matches ? initAsSlider() : initAsGrid();
				return;
			}

			if (totalSlides <= slickConfig.slidesToShow) {
				$wrapper.addClass('no-slide');
				$currentSlider.addClass('is-grid');
				return;
			}

			$currentSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				if ($progressBar.length) {
					// Calculate progress
					const calc = (nextSlide / (slick.slideCount - 1)) * 100;
					// Update progress bar
					$progressBar.css('background-size', calc + '% 100%');
				}
			});

			$currentSlider.slick(slickConfig);
		});
	}
};

export default Sliders;
